export default {
  init: function() {
    Kadenze.Analytics.track('course', 'view', {course: JSON.parse($('#course_json').val())});
    console.log('StudentCourseDashboard initialization function called');
  }
};
